import textCommon from './th/common.json'
import textDisplay from './th/display.json'
import textControlDisplay from './th/controlDisplaySchedule.json'
import textValidate from './th/validate.json'

export default {
   ...textCommon,
   "display": {
      ...textDisplay
   },
   "controlDosplaySchedule": {
      ...textControlDisplay
   },
   "validate":{
      ...textValidate
   }
}



// WEBPACK FOOTER //
// ./src/language/th.js